var React = require('react');
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var moment = require('moment');
var NavList = require('./navList.jsx');
var SurveyEntryMyGi = require('./surveyEntryMyGi.jsx');

var DashboardNavMyGi = createReactClass({
    mixins: [PureRenderMixin],

    componentDidMount: function(){
        this.resetActiveItems();
    },

    handleClick: function(){
        this.resetActiveItems();
        this.props.clickTracking('Click', 'Symptom Snapshot');
    },

    componentWillReceiveProps: function(nextProps){
        if(nextProps.activeItems.length === 0){
            this.resetActiveItems();
        }
    },

    resetActiveItems: function(){
        this.props.setActiveItems(
            this.props.score.data.filter(function(scoreItem){
                return scoreItem.percentile > 0;
            }).map(function(scoreItem){
                return scoreItem.item;
            }),
            true // isSnapShot
        );
    },

    render: function(){
        var nonHistoryZeroScoreItems = this.props.score.data.filter(function(scoreItem){
            return !!this.props.id2ItemScoresData[scoreItem.item.id];
        }.bind(this));

        return (
            <div className="dashboard-nav">
                <div className={'dashboard-nav-header' + (this.props.isSnapShot ? ' is-active' : '')} onClick={this.handleClick}>
                    <h1 className="show-for-medium">Symptom Snapshot</h1>
                    <p>
                        <span className="show-for-small-only">{moment(this.props.score.timeStamp).format('dddd, MMMM Do [at] h:mm a')}</span>
                        <span className="show-for-medium">{moment(this.props.score.timeStamp).format('MMMM D, YYYY')}</span>
                    </p>
                </div>
                <NavList
                    scoreItems={nonHistoryZeroScoreItems}
                    activeItems={this.props.activeItems}
                    isSnapShot={this.props.isSnapShot}
                    addActiveItem={this.props.addActiveItem}
                    removeActiveItem={this.props.removeActiveItem}
                    id2ItemScoresData={this.props.id2ItemScoresData}
                    clickTracking={this.props.clickTracking} />
                <SurveyEntryMyGi className="expanded" daysBeforeLatestSurvey={this.props.daysBeforeLatestSurvey} clickTracking={this.props.clickTracking} />
            </div>
        )
    }
});

module.exports = DashboardNavMyGi;



// WEBPACK FOOTER //
// ./src/common/routes/dashboard/components/layout/dashboardNavMyGi.jsx